import { DefaultState, IState } from "./state";
import { Keys, Types } from "./actions/types";

export const reducer = (state: IState = DefaultState(), action: Types): IState => {
    switch (action.type) {
        case Keys.LOADSTATS_PENDING:  {
            return {
                ...state,
               loadingUserStats: true,
               errorFetchUserStats: false,
            }
        }
        case Keys.LOADSTATS_FULFILLED: {
            return {
                ...state,
                stats: action.payload,
                loadingUserStats: false,
            }
        }
        case Keys.LOADSTATS_REJECTED: {
            return {
                ...state,
                loadingUserStats: false,
                errorFetchUserStats: true,
            }
        }
       default:
            return state;
    }
} 